import { CreateGUID, createID } from "./funlib";

import { ng } from "../ngds";

// ------------------ G E T T E R S --------------------------

export function getMtrl(guid: string, input: ng.input.IData) {
  if (input == null) return null;

  let mtrl = input.mtrlDb?.find((m) => m.id?.guid === guid);

  return mtrl ?? null;
}

export function getNode(guid: string, input: ng.structure.IData): ng.topology.ElementNode {
  if (input === null) return ng.topology.ElementNode.create();

  let node = input.nodes?.find((m) => m.id?.guid === guid);

  return node ?? ng.topology.ElementNode.create();
}

export function getSec(guid: string, input: ng.input.IData) {
  if (input == null) return null;

  let sec = input.secDb?.find((m) => m.id?.guid === guid);

  return sec ?? null;
}

export type SecGuid = [string, string];
export type SectionSection = [ng.sections.Section, ng.sections.Section];
export function getSecs(guid: SecGuid, input: ng.input.Data): SectionSection | null {
  const secDB = input.secDb;
  let sec1 = secDB.find((m) => m.id?.guid === guid[0]);
  let sec2 = secDB.find((m) => m.id?.guid === guid[1]);

  return sec1 && sec2 ? [sec1, sec2] : null;
}

export function getSup(guid: string, input: ng.structure.Data) {
  const stageSups = input?.stages?.[0]?.sups;
  if (!stageSups) {
    return null;
  }
  const matchingSup = stageSups.find((sup) => sup.guid === guid);
  return matchingSup || null;
}

export function getLoad(guid: string, input: ng.structure.Data): [ng.load.Data, number] | null {
  const loads = input?.loading?.loads;
  if (!loads) {
    return null;
  }
  const matchingLoad = loads.find((load) => load.id?.guid === guid);
  const index = loads.findIndex((load) => load.id?.guid === guid);
  if (matchingLoad === undefined) return null;
  return [matchingLoad, index];
}

export function getLoadcomb(guid: string, input: ng.structure.Data_json) {
  const loadcombinations = input?.loading?.combinations;
  if (!loadcombinations) {
    return null;
  }
  const matchingLoadcomb = loadcombinations.find((loadcomb) => loadcomb.id?.guid === guid);
  const index = loadcombinations.findIndex((loadcomb) => loadcomb.id?.guid === guid);
  return [matchingLoadcomb, index];
}

export function getLoadcase(guid: string, input: ng.structure.Data): [ng.loadcase.Data, number] | null {
  const loadcases = input?.loading?.loadcases;
  if (!loadcases) {
    return null;
  }
  const matchingLoadcase = loadcases.find((loadcase) => loadcase.id?.guid === guid);
  const index = loadcases.findIndex((loadcase) => loadcase.id?.guid === guid);
  if (matchingLoadcase === undefined) return null;
  return [matchingLoadcase, index];
}
export function getLoadcaseX(guid: string, input: ng.structure.IData): ng.loadcase.IData | null {
  const loadcases = input?.loading?.loadcases;
  if (!loadcases) {
    return null;
  }
  const matchingLoadcase = loadcases.find((loadcase) => loadcase.id?.guid === guid);
  return matchingLoadcase || new ng.loadcase.Data();
}

export function getLoadcaseFactor(
  lcombGuid: string,
  lcaseGuid: string,
  structure: ng.structure.Data_json,
  type: ng.loadcombination.CoefficientType = ng.loadcombination.CoefficientType.COEFFICIENT_TYPE_GAMMA,
): number {
  const loadcomb = getLoadcomb(lcombGuid, structure);
  const loadcombInfo = loadcomb?.[0];
  if (!loadcombInfo) {
    return 0.0;
  }
  const part = (loadcombInfo as ng.loadcombination.Data_json).parts.find((part) => part.lcaseGuid === lcaseGuid);
  if (part) {
    const factor = part.coefficients.find((coeff: any) => coeff.type === type)?.value || 0.0;
    return (factor as number) || 0.0;
  }
  return 0.0;
}

export function getHighestMagnitudeLoad(input: ng.structure.Data): ng.load.Data | null {
  const loads = input?.loading?.loads;
  if (!loads) {
    return null;
  }
  const maxLoad = loads.reduce((prev: any, current: any) => {
    if (!prev.values || !current.values) return null;
    return Math.max(...prev.values) > Math.max(...current.values) ? prev : current;
  });
  return maxLoad || null;
}

export function addSup(guid: string) {
  const defaultSup = ng.support.Data.create({
    id: ng.utils.ID.create({
      guid: guid,
      name: "",
    }),
  });
  return defaultSup;
}

export function addStageSup() {
  const defaultSup = ng.stage.Support.create({
    guid: CreateGUID(),
    coord: ng.geometry.Point3D.create({
      x: 0.0,
      y: 0.0,
      z: 0.0,
    }),
    lateral: false,
    supportLevel: ng.stage.SupportLevel.SUPPORT_LEVEL_UNSPECIFIED,
    con: ng.topology.Connectivity.create({
      //set "roller" by default
      // local_coord_sys:{},
      transX: ng.topology.Stiffness.create({
        value: 0,
        type: ng.topology.StiffnessType.STIFFNESS_TYPE_SPRING,
      }),
      transY: ng.topology.Stiffness.create({
        value: -1,
        type: ng.topology.StiffnessType.STIFFNESS_TYPE_SPRING,
      }),
      transZ: ng.topology.Stiffness.create({
        value: -1,
        type: ng.topology.StiffnessType.STIFFNESS_TYPE_SPRING,
      }),
      rotX: ng.topology.Stiffness.create({
        value: 0,
        type: ng.topology.StiffnessType.STIFFNESS_TYPE_SPRING,
      }),
      rotY: ng.topology.Stiffness.create({
        value: 0,
        type: ng.topology.StiffnessType.STIFFNESS_TYPE_SPRING,
      }),
      rotZ: ng.topology.Stiffness.create({
        value: 0,
        type: ng.topology.StiffnessType.STIFFNESS_TYPE_SPRING,
      }),
    }),
  });
  return defaultSup;
}

export function addBar() {
  const defaultBar = ng.reinf.Straight.create({
    guid: CreateGUID(),
    layGuid: "",
    vPos: ng.reinf.VertPos.VERT_POS_CENTER,
    hPos: ng.reinf.HorPos.create({
      start: 0,
      end: 0,
    }),
    // fullyAnchoredAtEnd: false,
    // fullyAnchoredAtStart: false,
  });
  return defaultBar;
}
